package com.narbase.narnic.trial.utils.popup

import com.narbase.kunafa.core.components.*
import com.narbase.kunafa.core.components.layout.LinearLayout
import com.narbase.kunafa.core.css.*
import com.narbase.kunafa.core.dimensions.dependent.wrapContent
import com.narbase.kunafa.core.dimensions.px
import com.narbase.kunafa.core.dimensions.vh
import com.narbase.kunafa.core.dimensions.vw
import com.narbase.kunafa.core.drawable.Color
import kotlinx.browser.document

/**
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017] -[2018] Narbase Technologies
 * All Rights Reserved.
 * Created by ${user}
 * On: ${Date}.
 */
class PopUpDialog(val onDismissed: (() -> Unit)? = null) {

    var onDialogDismissEvent: (() -> Unit)? = null

    private val background by lazy {

        detached.verticalLayout {
            style {
                zIndex = 200
            }
            isVisible = false

        }
    }


    fun setup(parent: View) {
        parent.mount(background)
    }

    fun showDialog(
        isDismissible: Boolean = true,
        shouldDismiss: (() -> Boolean)? = null,
        onDialogDismissEvent: (() -> Unit)? = null,
        popupOptions: PopupOptions = PopupOptions(),
        block: LinearLayout.() -> Unit
    ) {
        this.onDialogDismissEvent = onDialogDismissEvent
        val dismissCondition = (shouldDismiss == null && isDismissible) || (shouldDismiss?.invoke() == true)
        background.isVisible = true
        background.clearAllChildren()
        background.mount(object : Component() {
            override fun View?.getView() =
                verticalLayout {
                    id = "PopUp background"
                    style("popup_dialog_background_layout") {
                        position = "fixed"
                        top = 0.px
                        left = 0.px
                        width = 100.vw
                        height = 100.vh
                        backgroundColor = Color(0, 0, 0, 0.7)
//                            this["backdrop-filter"] = "blur(2px)"
                        alignItems = Alignment.Center
                    }
                    style {
                        justifyContent = popupOptions.justifyContent
                        popupOptions.background?.let {
                            background = it
                        }
                    }
                    element.style.zIndex = PopupZIndex.getTopIndex().toString()
                    onClick = {
                        onDialogDismissEvent?.invoke()
                        if (dismissCondition) {
                            dismissDialog()
                        }
                    }

                    verticalLayout {
                        id = "PopUp Dialog inner views"
                        style("popup_dialog_inner_layout") {
                            width = wrapContent
                            height = wrapContent
                        }
                        onClick = { it.stopPropagation() }
                        block()
                    }
                }
        })
    }


    fun dismissDialog() {
        background.isVisible = false
        background.clearAllChildren()
        onDismissed?.invoke()
        onDialogDismissEvent?.invoke()
        PopupZIndex.restoreTopIndex()
    }

    class PopupOptions {
        var justifyContent: JustifyContent = JustifyContent.Center
        var background: String? = null
    }

    companion object {

        //        lateinit var popUpRootView: View
        val popUpRootView: View by lazy {
            detached.view {
                style {
                    width = 0.px
                    height = 0.px
                }
            }.also { document.body?.append(it.element) }
        }

        val pdfViewer by lazy { popUpDialog { } }
    }
}


fun popUpDialog(onDismissed: (() -> Unit)? = null): PopUpDialog {
    return PopUpDialog(onDismissed).apply {
        setup(PopUpDialog.popUpRootView)
    }
}
